import { isOfTypeSematicTextColor, SemanticTextColor } from '@foradevelopment/design-tokens';
import { semanticColors } from '@foradevelopment/design-tokens/nested';

import { colors } from '../styles/colors';
import { Colors } from './types';

/**
 * Returns the hex code for text color. The function is backward compatible with the old Colors type.
 *
 * @param {Colors | SemanticTextColor} color Name of the color. Use {@link SemanticTextColor} type if possible.
 * @returns {string} hex code
 */
export const getSemanticTextColor = (color: Colors | SemanticTextColor): string =>
  isOfTypeSematicTextColor(color) ? semanticColors.semantic.color.text[color] : colors[color];
